import script from "./ColorPick.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorPick.vue?vue&type=script&lang=ts&setup=true"

import "./ColorPick.vue?vue&type=style&index=0&id=75e32be1&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e32be1"]])

export default __exports__